import { CheckCircle, AlertCircle, Clock, Loader2 } from 'lucide-react';

const StatusBadge = ({ status }) => {
  const config = {
    COMPLETED:              { bg: 'bg-emerald-500/10 border-emerald-500/20', text: 'text-emerald-400', icon: CheckCircle, label: 'Synced' },
    COMPLETED_WITH_WARNINGS:{ bg: 'bg-amber-500/10 border-amber-500/20',    text: 'text-amber-400',   icon: AlertCircle, label: 'Warnings' },
    FAILED:                 { bg: 'bg-red-500/10 border-red-500/20',        text: 'text-red-400',     icon: AlertCircle, label: 'Failed' },
    RUNNING:                { bg: 'bg-blue-500/10 border-blue-500/20',      text: 'text-blue-400',    icon: Loader2,     label: 'Syncing' },
    IDLE:                   { bg: 'bg-gray-500/10 border-gray-500/20',      text: 'text-gray-400',    icon: Clock,       label: 'Idle' },
    PENDING:                { bg: 'bg-gray-500/10 border-gray-500/20',      text: 'text-gray-400',    icon: Clock,       label: 'Pending' },
    NEVER_SYNCED:           { bg: 'bg-gray-500/10 border-gray-600/20',      text: 'text-gray-500',    icon: Clock,       label: 'Not synced' },
  };
  const c = config[status] || config.IDLE;
  const Icon = c.icon;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-[11px] font-medium border ${c.bg} ${c.text}`}>
      <Icon className={`w-3 h-3 ${status === 'RUNNING' ? 'animate-spin' : ''}`} />
      {c.label}
    </span>
  );
};

export default StatusBadge;
